import {useRankedBrandTraits} from "./brand-traits";
import {useEffect, useState} from "react";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {httpsCallable} from "firebase/functions";
import {functions} from "hooks/firebase";
import {RecommendedFontsRequest, RecommendedFontsResponse} from "data/models/shared/recommended-fonts";


export function useRecommendedFonts(): [RecommendedFontsResponse | null, boolean, Error | null] {
  const [rankedBrandTraits, rankedTraitsLoading, rankedTraitsError] = useRankedBrandTraits();

  const [error, setError] = useState<Error | null>(null);

  const [recommendedFonts, setRecommendedFonts] = useState<RecommendedFontsResponse | null>(null);

  useEffect(() => {
    const anError = (
        rankedTraitsError
    );
    if (!isNullOrUndefined(anError)) {
      setError(anError);
      return;
    }
    if (rankedTraitsLoading) {
      return;
    }
    if (isNullOrUndefined(rankedBrandTraits)) {
      return;
    }

    const recommendedFontsRequest = {
      rankedBrandTraits: rankedBrandTraits?.slice(0, 3).map(trait => trait.traitKey),
    };

    const recommendedFontsFunction = httpsCallable<RecommendedFontsRequest, RecommendedFontsResponse>(functions, 'recommendedFonts');

    recommendedFontsFunction(recommendedFontsRequest).then(result => {
      setRecommendedFonts(result.data);
      setError(null);
    }).catch((error) => {
      setError(error as Error);
    });

  }, [
    rankedBrandTraits, rankedTraitsLoading, rankedTraitsError,
  ]);

  return [recommendedFonts, rankedTraitsLoading, error];
}

